import { createAsyncThunk } from '@reduxjs/toolkit';
const base = process.env.REACT_APP_API_URL + '/job-titles';
async function request(path, options, { signal, rejectWithValue }) {
  try {
    const response = await fetch(base + path, { ...options, signal, headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + localStorage.getItem('token') } });
    const data = await response.json();
    return response.ok ? data : rejectWithValue(data.error || data.message || 'Unable to complete the request.');
  } catch (error) { return rejectWithValue(error.message || 'Unable to connect.'); }
}
export const fetchJobTitles = createAsyncThunk('jobTitles/list', (_, api) => request('', { method: 'GET' }, api));
export const saveJobTitle = createAsyncThunk('jobTitles/save', ({ id, data }, api) => request(id ? '/' + encodeURIComponent(id) : '', { method: id ? 'PUT' : 'POST', body: JSON.stringify(data) }, api));
export const fetchJobTitleCheckOptions = createAsyncThunk('jobTitles/checkOptions', (_, api) => request('/check-options', { method: 'GET' }, api));
